import React from "react";
import { Column } from "components/Layout/Grid";
import Text from "components/Text";

export interface IUnansweredDetailItem {
  item?: string | number;
  code?: string;
  description?: string;
  preferedBrands?: string;
  unidade?: string;
  mensagem?: string;
  product?: {
    unitPurchase?: string;
    description?: string;
    code?: string;
  };
  sequenceNumber?: string | number;
}

export interface IUnansweredRow {
  id?: string;
  code?: string;
  createdAt?: string;
  customerName?: string;
  razaoSocial?: string;
  category?: string;
  qtd?: number;
  status?: string;
  statusDescription?: string;
  supplierStatus?: string;
  expiresAt?: string;
  origin?: string;
  items?: IUnansweredDetailItem[];
  company?: { crmCustomerCode?: string };
}

/** Larguras fixas (px) para alinhar título e dados dos sub-itens */
const DETAIL_COLUMNS = [
  { key: "item", label: "Item", width: 90 },
  { key: "code", label: "Código", width: 160 },
  { key: "description", label: "Descrição", width: 350 },
  { key: "preferedBrands", label: "Marca", width: 135 },
  { key: "product.unitPurchase", label: "Unidade", width: 260 },
  { key: "mensagem", label: "Mensagem", width: 135 },
] as const;

/** Grid com colunas que podem encolher (minmax(0, Xpx)) para não ultrapassar a largura da coluna */
const gridTemplateColumns = DETAIL_COLUMNS.map((c) => `minmax(0, ${c.width}px)`).join(" ");

/** Retorna o valor da célula; item, código, descrição e unidade vêm de product */
function getDetailCellValue(item: IUnansweredDetailItem, key: string): string {
  if (key === "item") {
    return String(item?.sequenceNumber ?? item.item ?? "-");
  }
  if (key === "product.unitPurchase") {
    return String(item.product?.unitPurchase ?? item.unidade ?? "-");
  }
  if (key === "description") {
    return String(item.product?.description ?? item.description ?? "-");
  }
  if (key === "code") {
    return String(item.product?.code ?? item.code ?? "-");
  }
  const value = item[key as keyof IUnansweredDetailItem];
  return typeof value === "object" ? "-" : String(value ?? "-");
}

export const UnansweredItemsDetailDropdown: React.FC<IUnansweredRow> = (row) => {
  const detailItems = row.items ?? [];

  return (
    <Column
      className="animated fadeIn bg-white py-3 unanswered-items-detail-dropdown"
      style={{
        marginLeft: 0,
        width: "100%",
        maxWidth: "100%",
        minWidth: 0,
        paddingLeft: 20,
        paddingRight: 20,
        overflow: "hidden",
        boxSizing: "border-box",
      }}
    >
      <Text className="font-bold color-blue-gray mt-2 mb-3" size={12}>
        {detailItems.length > 0
          ? ""
          : "Sem itens para exibir"}
      </Text>
      {detailItems.length > 0 && (
        <div className="unanswered-detail-grid-wrapper" style={{ overflowX: "auto", maxWidth: "99%", minWidth: 0 }}>
          <div className="unanswered-detail-grid" style={{ width: "100%", minWidth: 0 }}>
            <div
              className="unanswered-detail-grid-row unanswered-detail-grid-header"
              style={{ display: "grid", gridTemplateColumns }}
            >
              {DETAIL_COLUMNS.map((col, colIdx) => (
                <div
                  key={col.key}
                  className="d-flex align-center py-2 px-2 text-left font-bold"
                  style={{
                    minWidth: 0,
                    backgroundColor: "#D0DEE1",
                    color: "#2d3748",
                    fontSize: 12,
                    borderTopLeftRadius: colIdx === 0 ? 8 : 0,
                    borderTopRightRadius: colIdx === DETAIL_COLUMNS.length - 1 ? 8 : 0,
                  }}
                >
                  {col.label}
                </div>
              ))}
            </div>
            {detailItems.map((item, idx) => (
              <div
                key={idx}
                className="unanswered-detail-grid-row"
                style={{
                  display: "grid",
                  gridTemplateColumns,
                  minHeight: 50,
                  alignItems: "start",
                  backgroundColor: idx % 2 === 0 ? "#ffffff" : "#F5F7F8",
                }}
              >
                {DETAIL_COLUMNS.map((col) => (
                  <div
                    key={col.key}
                    className={`color-blue-gray text-left py-2 px-2${
                      col.key === "description" || col.key === "preferedBrands" ? " unanswered-detail-grid-cell--wrap" : ""
                    }`}
                    style={{
                      minWidth: 0,
                      maxWidth: "100%",
                      fontSize: 12,
                      ...(col.key === "description" || col.key === "preferedBrands"
                        ? {}
                        : {
                            overflow: "hidden",
                            textOverflow: "ellipsis",
                            whiteSpace: "nowrap",
                          }),
                    }}
                  >
                    {getDetailCellValue(item, col.key)}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
      )}
    </Column>
  );
};
